import {
  type RawDraftContentState,
  type RawEntity,
  escapeAttr,
  escapeText,
  raGetBlockHTML,
  renderBlocks,
} from './draftConvertCore';

export const makeSnippetMarker = (data: unknown): string => {
  return `<div data-ra-snippet="${encodeURIComponent(
    JSON.stringify(data),
  )}"></div>`;
};

export const makeCustomHtmlMarker = (html: string): string => {
  return `<div data-ra-custom-html="${encodeURIComponent(html)}"></div>`;
};

const entityToCanonicalHTML = (
  entity: RawEntity,
  originalText: string,
): any => {
  if (entity.type === 'LINK') {
    const url = entity.data.url;
    if (url == null) {
      return originalText;
    }
    return `<a href="${escapeAttr(url)}">${originalText}</a>`;
  }
  if (entity.type === 'PROPERTY_SNIPPET') {
    return makeSnippetMarker(entity.data);
  }
  if (entity.type === '#mention') {
    const id = entity.data.mention?.id ?? entity.data.mention?.name;
    if (id == null) {
      return originalText;
    }
    return `<span data-ra-var="${escapeAttr(id)}">${originalText}</span>`;
  }
  if (entity.type === 'CUSTOM_HTML') {
    if (entity.data.html == null) {
      return originalText;
    }
    return makeCustomHtmlMarker(entity.data.html);
  }
  return originalText;
};

export const draftRawToCanonicalHtml = (rawJson: string): string => {
  try {
    const rawState = JSON.parse(rawJson) as RawDraftContentState;
    return renderBlocks(rawState, raGetBlockHTML, entityToCanonicalHTML);
  } catch {
    return `<p>${escapeText(rawJson)}</p>`;
  }
};

export const isDraftRawJson = (value: string): boolean => {
  try {
    const parsed = JSON.parse(value);
    return (
      parsed != null &&
      typeof parsed === 'object' &&
      Array.isArray(parsed.blocks)
    );
  } catch {
    return false;
  }
};
